module.exports = __webpack_public_path__ + "static/scale-model-of-colee-hammock-park-in-hollywood-florida-9b9dd8b3b72252beb7d16ec6879a325b.png";